import mensagens from '@/util/mensagens'
import { BToast, BSpinner } from 'bootstrap-vue'
import constants from '@/util/constants'
import util from '@/util'
import { mapState, mapActions } from 'vuex'
import { infraMixin } from '@/modules/infra/mixins'
import { obterImagem } from '@/util/imagem'
import PainelAcesso from '@/components/layout/painelAcesso/PainelAcesso.vue'

export default {
  name: 'AlteracaoSenhaLoginLite',
  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner,
    PainelAcesso
  },
  mixins: [infraMixin],

  computed: {
    ...mapState('auth', ['regrasLogin', 'loginStrategy']),
    obterLogo () {
      return obterImagem('logo-mirt.svg')
    }
  },

  data: () => {
    return {
      formulario: {
        senha_atual: null,
        nova_senha: null,
        confirmacao_senha: null
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      },
      flagsDeControle: {
        manipulandoDados: {
          status: false,
          mensagem: ''
        }
      },
      flagsValidacao: {
        isPasswordUppercaseValid: false,
        isPasswordLengthValid: false,
        isPasswordNumberValid: false
      }
    }
  },

  mounted () {
    this.limparListaErros()
  },

  methods: {
    ...mapActions('auth', ['ActionSignOut', 'ActionSetRegrasLogin']),
    validarSenha () {
      const novaSenha = this.formulario.nova_senha
      this.flagsValidacao.isPasswordLengthValid = novaSenha.length >= 8
      this.flagsValidacao.isPasswordUppercaseValid = /[A-Z]/.test(novaSenha)
      this.flagsValidacao.isPasswordNumberValid = /\d/.test(novaSenha)
    },

    async alterarSenha () {
      this.limparListaErros()
      try {
        this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)

        const resposta = await this.axios.post(this.obterUrlAlteracaoSenha(), this.obterDadosAlteracaoSenha())
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros

        await this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
        this.definirFlagManipulandoDados(false, '')
      }
    },

    obterUrlAlteracaoSenha () {
      // esse arquivo contempla apenas o contexto Mirt
      if (this.loginStrategy === constants.loginStrategy.legacyLogin) {
        return '/usuario/alterar/senha-primeiro-acesso'
      }

      return '/manager/signin/alteracao-senha'
    },

    obterDadosAlteracaoSenha () {
      if (this.loginStrategy === constants.loginStrategy.legacyLogin) {
        return {
          f_original_password: this.formulario.senha_atual,
          f_new_password: this.formulario.nova_senha,
          f_confirm_password: this.formulario.confirmacao_senha
        }
      }

      return this.formulario
    },

    async tratarAposSalvarRegistro () {
      if (this.retorno.sucesso) {
        this.emitirEventoFinalizacaoPendencia()
      } else {
        const mensagemRetorno = this.retorno.mensagem
        util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno)
        this.definirFlagManipulandoDados(false, '')
      }
    },

    emitirEventoFinalizacaoPendencia () {
      const pendenciasLogin = JSON.parse(this.regrasLogin)
      pendenciasLogin.deveAlterarSenha = false
      this.ActionSetRegrasLogin(JSON.stringify(pendenciasLogin))

      if (this.loginStrategy === constants.loginStrategy.legacyLogin) {
        this.ActionSignOut()
        this.$router.push({ name: constants.nomeRotaLogin })
        return
      }

      this.$emit('finalizandoPendencia', (componentePai) => {
        util.criarAlertaToastDeSucesso(componentePai, 'Aviso', 'Dados salvos com sucesso')
      })
    },

    limparListaErros () {
      this.retorno.listaDeErros = {}
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    eventoLoginTeclaEnter (evento) {
      if (evento.keyCode === constants.teclado.enter) {
        this.alterarSenha()
      }
    }
  }
}
